import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { callGetCollectionTraits } from '@app/client/resources/yat-pages/page-items';
import { PathParams } from '@app/routes/types';

import { useNFTMainData } from './useNFTMainData';

// Note: This would be replaced once we update the BE endpoint
// we would just send an array of traits
const MAX_TRAITS_ALLOWED = 7;

export const useNFTMainTraitData = () => {
    const { [PathParams.Contract]: contract, [PathParams.Id]: itemId } = useParams();

    const { data } = useNFTMainData();
    const cache = ['collectionTraits', contract, itemId];
    // TODO: Right now we are pulling all traits, we need a filter

    return useQuery(
        cache,
        ({ signal }) =>
            callGetCollectionTraits({
                contract: contract || '',
                itemId: itemId || '',
                settings: {
                    signal,
                },
            }),
        {
            retry: false,
            enabled: Boolean(
                contract && itemId && (data?.attributes?.length || MAX_TRAITS_ALLOWED) < MAX_TRAITS_ALLOWED,
            ),
        },
    );
};
